import { GET_BANK_ACCOUNT_URL, UPDATE_BANK_ACCOUNT_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getBankAccountDetails = () => onResponse => {
    try {
        axiosInstance.get(GET_BANK_ACCOUNT_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const updateBankAccountDetails = (props) => onResponse => {
    try {
        axiosInstance.post(UPDATE_BANK_ACCOUNT_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};